import { render, staticRenderFns } from "./TitluPagina.vue?vue&type=template&id=1c9579d6&scoped=true&"
import script from "./TitluPagina.vue?vue&type=script&lang=js&"
export * from "./TitluPagina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9579d6",
  null
  
)

export default component.exports